import React from 'react'

import theme from 'theme'

import Text from './Text'

type FormSubtextProps = {
  isInvalid?: boolean
  isValid?: boolean
}

const FormSubtext: React.FC<FormSubtextProps> = ({
  children,
  isValid,
  isInvalid,
  ...rest
}) =>
  children ? (
    <Text
      as="small"
      css={{
        marginTop: theme.space[1],
        ...(isValid && { color: theme.colors.green[0] }),
        ...(isInvalid && { color: theme.colors.red[0] })
      }}
      {...rest}
    >
      {children}
    </Text>
  ) : null

export default FormSubtext
